import { redirect } from "react-router-dom";
import { logout } from "../../../data/auth.service";

export async function loader({ params }) {

    await logout();


    return redirect(`/login`);
}